import { logoutWtApp } from "../androidAndIosApp";
import { isAppTypeIframe } from "../getAppType";
import { useSettings } from "../settings/useSettings";
import { getRedirectProps, redirect } from "./redirect";
import { useKeycloakAuth } from "../business-components/adminSettings/AdminContext";
import { useWhoAmI } from "../user/useWhoAmI";

export const useLogOut = () => {
  const settings = useSettings();
  const useKeycloak = useKeycloakAuth();
  const { whoAmI } = useWhoAmI();

  return () => {
    if (window.iswtapp) {
      logoutWtApp();
    }

    let params = new URLSearchParams();

    if (window.cvpIdConcern) {
      params.append("k", window.cvpIdConcern.toString());
    }

    let urlToGoToAfterLogout = isAppTypeIframe()
      ? settings.iframe_startPage
      : "/";

    const redirectUri = getRedirectProps(urlToGoToAfterLogout, {
      mergeQs: {
        k: window.cvpIdConcern ?? null,
      },
    }).href;

    const searchParams = new URLSearchParams();
    searchParams.set("redirectUri", redirectUri);
    const qs = searchParams.toString();

    // Prefer dedicated auth-skipped logout when running auth-skipped sessions.
    let authProvider = "";
    if (whoAmI?.provider === "AuthSkippedLogin") {
      authProvider = "authskippedlogin/";
    } else if (useKeycloak) {
      // Use Keycloak only when toggle is enabled (for local IP users)
      authProvider = "keycloak/";
    }

    redirect(`${location.origin}/auth/${authProvider}logout?${qs}`, {
      mergeQs: {},
      redirectRaw: true,
    });
  };
};
